export default __webpack_public_path__ + "static/media/assistance.8225731c.png";